import { Popover as PopoverPrimitive } from "@kobalte/core";
import { type JSX, splitProps } from "solid-js";
import { cn } from "@stockpilot/shared";

import { overlayPortalHost } from "./overlay-portal";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;

export function PopoverContent(
  props: PopoverPrimitive.PopoverContentProps & { class?: string; children?: JSX.Element },
) {
  const [local, others] = splitProps(props, ["class", "children"]);
  return (
    // mount: host data-live-announcer para que el Popover sea alcanzable dentro
    // de un Dialog modal (ariaHideOutside) — ver overlay-portal.ts (CC-21).
    <PopoverPrimitive.Portal mount={overlayPortalHost()}>
      <PopoverPrimitive.Content
        class={cn(
          // z-[220]: por ENCIMA del Dialog (overlay z-[200], contenido z-[210]);
          // con z-50 el popover quedaba visualmente DEBAJO del modal (CC-21).
          "z-[220] w-72 rounded-md border border-border bg-popover p-4 text-popover-foreground shadow-md outline-none animate-in fade-in zoom-in-95 duration-200",
          local.class,
        )}
        {...others}
      >
        {local.children}
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>
  );
}
